import React from 'react';
import { motion } from 'framer-motion';
import { Droplets, Sun, Wind, Hexagon } from 'lucide-react';
const methods = [{
  name: 'Washed',
  desc: "Bright, clean, and crisp, showcasing the coffee's true character.",
  icon: Droplets,
  color: 'bg-blue-50 text-blue-600'
}, {
  name: 'Natural',
  desc: 'Fruity and full-bodied, with bold, sweet flavors.',
  icon: Sun,
  color: 'bg-orange-50 text-orange-600'
}, {
  name: 'Anaerobic',
  desc: 'Complex and intense, layered with vibrant notes.',
  icon: Hexagon,
  color: 'bg-purple-50 text-purple-600'
}, {
  name: 'Yellow Honey',
  desc: 'Smooth and sweet, with a syrupy body and balanced acidity.',
  icon: Wind,
  color: 'bg-yellow-50 text-yellow-600'
}];
export function ProcessingSection() {
  return <section id="processing" className="py-20 md:py-32 bg-white" data-id="element-131">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="mb-16" data-id="element-133">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-134">
            <span className="text-brand-red font-display font-bold uppercase tracking-widest block mb-2" data-id="element-135">
              Craftsmanship
            </span>
            <h2 className="text-4xl md:text-5xl font-display font-bold text-brand-black mb-6" data-id="element-136">
              Our Coffee Processing
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl" data-id="element-137">
              We employ meticulous processing methods to bring out the unique
              potential of every bean harvested from our farms.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-138">
          {methods.map((method, index) => <motion.div key={method.name} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative group" data-id="element-139">
              <div className="h-full p-8 bg-brand-cream rounded-sm border-t-4 border-transparent hover:border-brand-red transition-all duration-300 hover:shadow-xl" data-id="element-140">
                <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-6 ${method.color} group-hover:bg-brand-red group-hover:text-white transition-colors duration-300`} data-id="element-141">
                  <method.icon size={28} data-id="element-142" />
                </div>

                <h3 className="text-xl font-display font-bold text-brand-black mb-3 group-hover:text-brand-red transition-colors" data-id="element-143">
                  {method.name}
                </h3>

                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-144">
                  {method.desc}
                </p>

                <div className="absolute top-4 right-4 text-6xl font-display font-bold text-gray-200 -z-0 opacity-50 group-hover:opacity-20 transition-opacity" data-id="element-145">
                  0{index + 1}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}